// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./dev/stylist_parent/components/panel/style.scss
// module id = 768
// module chunks = 0